{
  "common": {
    "buttons": {
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "submit": "Submit",
      "back": "Back",
      "edit": "Edit",
      "login": "Log in",
      "register": "Register",
      "createAccount": "Create account",
      "backToLogin": "Back to log in",
      "logout": "Log out",
      "create": "Create",
      "refresh": "Refresh"
    },
    "labels": {
      "email": "Email",
      "password": "Password"
    },
    "success": "Success",
    "errors": {
      "title": "Error",
      "error": "Error",
      "network": "Network error occurred",
      "unknown": "An unexpected error occurred",
      "loadFailed": "Failed to load data",
      "operationFailed": "Operation failed. Please try again.",
      "sessionExpired": "Session Expired",
      "sessionExpiredMessage": "Your session has expired. Please log in again to continue.",
      "authenticationRequired": "Authentication Required",
      "authenticationRequiredMessage": "Your session has expired. Please log in again.",
      "accessDenied": "Access Denied",
      "accessDeniedMessage": "You do not have permission to perform this action.",
      "serviceUnavailable": "Service Unavailable",
      "serviceUnavailableMessage": "The service is temporarily unavailable. Please try again later.",
      "connectionError": "Connection Error",
      "checkConnection": "Please check your internet connection and try again.",
      "unauthorized": "Unauthorized",
      "loginFailed": "Login failed. Please try again."
    },
    "validation": {
      "allFieldsRequired": "Please fill in all fields",
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 6 characters",
      "passwordMismatch": "Passwords do not match",
      "nameRequired": "Name is required",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "titleRequired": "Title is required",
      "descriptionRequired": "Description is required",
      "priceRequired": "Price is required",
      "priceInvalid": "Price must be a valid number",
      "sizeRequired": "Size is required",
      "categoryRequired": "Category is required",
      "conditionRequired": "Condition is required",
      "clubRequired": "Club is required",
      "invalidCredentials": "Invalid email or password",
      "emailNotConfirmed": "Please verify your email address before logging in",
      "emailAlreadyExists": "This email is already registered",
      "maxImagesReached": "Maximum 2 images allowed",
      "uploadFailed": "Upload failed. Please try again.",
      "rateLimitReached": "Too many uploads. Please wait.",
      "invalidImageType": "Only JPEG, PNG, and WebP are supported",
      "imageTooLarge": "Image too large. Maximum 10MB.",
      "permissionDenied": "Permission to access media library was denied"
    },
    "loading": "Loading...",
    "loadingMore": "Loading more...",
    "noData": "No data available",
    "optional": "(optional)",
    "refresh": "Refresh",
    "select": "Select",
    "search": "Search",
    "noResults": "No results found",
    "relativeTime": {
      "justNow": "Just now",
      "minutesAgo_one": "{{count}} minute ago",
      "minutesAgo_other": "{{count}} minutes ago",
      "hoursAgo_one": "{{count}} hour ago",
      "hoursAgo_other": "{{count}} hours ago",
      "yesterday": "Yesterday",
      "daysAgo_one": "{{count}} day ago",
      "daysAgo_other": "{{count}} days ago",
      "lastWeek": "Last week"
    }
  },
  "auth": {
    "reauth": {
      "title": "Session Expired",
      "message": "Your session has expired. Please log in again to continue.",
      "submit": "Log In"
    }
  },
  "enums": {
    "category": {
      "jersey": "Jersey",
      "shorts": "Shorts",
      "socks": "Socks",
      "jacket": "Jacket",
      "other": "Other"
    },
    "condition": {
      "new": "New",
      "like-new": "Like new",
      "good": "Good",
      "fair": "Fair"
    },
    "status": {
      "available": "Available",
      "reserved": "Reserved",
      "sold": "Sold"
    },
    "clubRole": {
      "member": "Member",
      "manager": "Manager"
    }
  },
  "screens": {
    "login": {
      "title": "Clubswap",
      "subtitle": "Sporting Club Marketplace",
      "email": "Email",
      "emailPlaceholder": "Enter your email",
      "password": "Password",
      "passwordPlaceholder": "Enter your password",
      "loginFailed": "Login failed",
      "forgotPassword": "Forgot password?"
    },
    "register": {
      "title": "Create account",
      "subtitle": "Join the marketplace of your club — buy and sell outgrown kit with people you already know.",
      "firstName": "First Name",
      "firstNamePlaceholder": "Enter your first name",
      "lastName": "Last Name",
      "lastNamePlaceholder": "Enter your last name",
      "preferredLanguage": "Preferred Language",
      "selectClubs": "Select Your Clubs (Optional)",
      "selectClubsHint": "You can join clubs later",
      "name": "Name",
      "namePlaceholder": "Enter your name",
      "email": "Email",
      "emailPlaceholder": "Enter your email",
      "password": "Password",
      "passwordPlaceholder": "Enter your password",
      "confirmPassword": "Confirm Password",
      "confirmPasswordPlaceholder": "Confirm your password",
      "success": "Success",
      "successMessage": "Account created! Please check your email to verify your account.",
      "registrationFailed": "Registration failed"
    },
    "forgotPassword": {
      "title": "Reset password",
      "subtitle": "Enter your email and we'll send you a reset link",
      "emailPlaceholder": "Enter your email",
      "sendResetLink": "Send reset link",
      "successTitle": "Check your email",
      "successMessage": "We've sent a password reset link to your email. Please check your inbox.",
      "failed": "Failed to send reset link"
    },
    "resetPassword": {
      "title": "Set new password",
      "subtitle": "Enter your new password below",
      "newPassword": "New Password",
      "newPasswordPlaceholder": "Enter new password",
      "confirmPassword": "Confirm Password",
      "confirmPasswordPlaceholder": "Confirm new password",
      "submit": "Update password",
      "successTitle": "Password reset",
      "successMessage": "Your password has been reset successfully.",
      "failed": "Failed to reset password",
      "invalidSession": "Invalid or expired reset link. Please request a new one."
    },
    "changePassword": {
      "title": "Change password",
      "currentPassword": "Current password",
      "currentPasswordPlaceholder": "Enter current password",
      "newPassword": "New password",
      "newPasswordPlaceholder": "Enter new password",
      "confirmPassword": "Confirm new password",
      "confirmPasswordPlaceholder": "Confirm new password",
      "submit": "Update password",
      "successTitle": "Password changed",
      "successMessage": "Your password has been changed successfully.",
      "failed": "Failed to change password",
      "incorrectCurrentPassword": "Current password is incorrect"
    },
    "home": {
      "title": "Clubswap",
      "recentFromClubs": "Recent from your clubs",
      "myListings": "My listings",
      "recentlyListedOverall": "Recently Listed Overall",
      "viewAll": "View all",
      "browseAll": "Browse All →",
      "viewMyListings": "View all",
      "noClubItems": "Nothing listed yet",
      "noClubItemsSubtext": "Be the first — list a piece of kit for your club.",
      "noItems": "No items available",
      "noItemsSubtext": "Be the first to list an item!",
      "noMyListings": "Sold something recently?",
      "noMyListingsSubtext": "Outgrown kit finds a new owner in your club within days.",
      "addFirstItem": "Add a listing",
      "loadError": "Failed to load home data"
    },
    "browse": {
      "title": "Browse",
      "searchPlaceholder": "Search gear…",
      "filterByClub": "Filter by club",
      "allClubs": "All clubs",
      "categoryAll": "All",
      "noResults": "No items found",
      "noResultsSubtext": "Try adjusting your search or filters",
      "itemCount_one": "{{count}} item",
      "itemCount_other": "{{count}} items",
      "inClub": "in {{club}}",
      "sortNewest": "Newest first",
      "sortPriceAsc": "Price: low to high",
      "loadError": "Failed to load items"
    },
    "itemDetails": {
      "deleteConfirm": "Delete listing",
      "deleteConfirmMessage": "Are you sure you want to delete this item?",
      "editItem": "Edit listing",
      "price": "Price",
      "size": "Size",
      "condition": "Condition",
      "category": "Category",
      "club": "Club",
      "seller": "Seller",
      "description": "Description",
      "noDescription": "No description provided",
      "deleteFailed": "Failed to delete item",
      "cannotDeleteTransaction": "Cannot delete - transaction in progress",
      "loadFailed": "Failed to load item details",
      "contactSellerMessage": "You can contact the seller via email to arrange purchase.",
      "itemMarkedReserved": "Item marked as reserved",
      "itemMarkedSold": "Item marked as sold",
      "itemDeleted": "Item deleted",
      "updateStatusFailed": "Failed to update item status",
      "markAsReserved": "Mark as Reserved",
      "markAsSold": "Mark as sold",
      "contactSeller": "Contact seller",
      "reportItem": "Report",
      "viewCount_one": "Viewed by {{count}} person",
      "viewCount_other": "Viewed by {{count}} people",
      "reportSuccess": "Thank you for your report. We will review it shortly.",
      "reportFailed": "Failed to submit report. Please try again.",
      "alreadyReported": "You have already reported this item.",
      "reportingItem": "Reporting item",
      "selectReason": "Select a reason for reporting",
      "additionalDetails": "Additional details",
      "detailsPlaceholder": "Provide more information about why you're reporting this item...",
      "reportReasons": {
        "inappropriate": "Inappropriate or offensive content",
        "scam": "Suspected scam or fraudulent listing",
        "copyright": "Copyright or trademark infringement",
        "other": "Other reason"
      },
      "startConversation": "Contact seller",
      "inConversation": "Open chat",
      "conversationExists": "You already have a conversation about this item",
      "startConversationFailed": "Failed to start conversation. Please try again.",
      "markSoldCta": "Mark as sold",
      "listed": "Listed {{when}}",
      "memberOf": "Member of {{club}}",
      "title": "Listing"
    },
    "markAsSold": {
      "title": "Sold to",
      "intro": "Who did you sell \"{{itemTitle}}\" to?",
      "askingPrice": "Asking {{price}}",
      "buyerLabel": "Buyer",
      "buyerPlaceholder": "Choose a buyer",
      "someoneElse": "Someone else",
      "buyerNameLabel": "Buyer name (optional)",
      "buyerNamePlaceholder": "E.g. a name or description",
      "priceLabel": "Sale price (optional)",
      "pricePlaceholder": "e.g. 12.50",
      "priceHint": "Defaults to your asking price. Change it if you sold for a different amount, or leave it blank.",
      "noConversations": "There are no conversations about this item yet. Choose \"Someone else\" if you sold it outside Clubswap.",
      "confirmButton": "Confirm sale",
      "confirmTitle": "Confirm sale",
      "confirmMessage": "Are you sure you want to mark this item as sold? The listing will go offline.",
      "selectBuyerError": "Choose a buyer or \"Someone else\"",
      "success": "The sale has been registered and your listing has been taken offline.",
      "failed": "Failed to register the sale. Please try again.",
      "loadFailed": "Failed to load data",
      "notAllowed": "Only the seller can mark this item as sold.",
      "invalidPrice": "Enter a valid amount, or leave the field empty.",
      "alreadySold": "This item is already registered as sold.",
      "buyerNotInConversation": "This buyer has no conversation about this item. Choose \"Someone else\".",
      "notAuthenticated": "You are no longer signed in. Please sign in again and retry."
    },
    "conversations": {
      "title": "Messages",
      "noConversations": "No conversations yet",
      "noConversationsSubtext": "Start a conversation with a seller to buy items.",
      "loadError": "Failed to load conversations",
      "seller": "Seller",
      "buyer": "Buyer",
      "noMessages": "No messages yet",
      "justNow": "Just now",
      "minutesAgo_one": "{{count}} minute ago",
      "minutesAgo_other": "{{count}} minutes ago",
      "hoursAgo_one": "{{count}} hour ago",
      "hoursAgo_other": "{{count}} hours ago",
      "daysAgo_one": "{{count}} day ago",
      "daysAgo_other": "{{count}} days ago",
      "count_one": "{{count}} conversation",
      "count_other": "{{count}} conversations",
      "itemDeleted": "Item deleted"
    },
    "chat": {
      "title": "Chat",
      "loadConversationError": "Failed to load conversation",
      "loadMessagesError": "Failed to load messages",
      "sendMessageError": "Failed to send message",
      "noMessages": "No messages yet",
      "noMessagesSubtext": "Start the conversation by sending a message",
      "unknownMember": "Club member",
      "conversationWith": "Conversation with",
      "typePlaceholder": "Type a message...",
      "send": "Send",
      "viewItem": "View item",
      "itemDeleted": "Item has been deleted",
      "closeEmptyChatTitle": "Close conversation?",
      "closeEmptyChatMessage": "You haven't sent any messages yet. If you close this chat, the conversation will be discarded and other buyers will be able to start conversations for this item again.",
      "reserved": "Reserved"
    },
    "privacy": {
      "title": "Privacy",
      "intro": "Clubswap connects members of sporting clubs to buy and sell second-hand children's clothing and equipment. This page explains, in plain language, what data we handle.",
      "dataTitle": "What we store",
      "dataBody": "Your account details (name, email, the clubs you join) and the listings and messages you create. We use this only to run the marketplace — to show listings, enable chats, and let you arrange a deal.",
      "paymentsTitle": "Payments",
      "paymentsBody": "During the launch phase, no money flows through Clubswap. Buyer and seller agree on a price in the app and settle in person at the club. We do not process payments or hold your bank details.",
      "statsTitle": "Usage statistics",
      "statsBody": "We keep anonymized, aggregated statistics on how the platform is used (such as the number of listings, views, chats and completed deals) to understand and improve the service. These aggregated statistics contain no personal data and may be shared with clubs, sporting federations and partners to demonstrate how the platform performs.",
      "rightsTitle": "Your rights",
      "rightsBody": "You can edit your profile at any time and delete your account from Settings, which removes your personal data. For questions about your data, contact us at privacy@clubswap.nl."
    },
    "profile": {
      "title": "Profile",
      "myListings": "My listings",
      "myClubs": "My clubs",
      "settings": "Settings",
      "languageSection": "Language",
      "memberSince": "Member since",
      "notSet": "Not set",
      "addListing": "Add",
      "adminDashboard": "Admin dashboard",
      "logoutConfirmMessage": "Are you sure you want to log out? You'll need to sign in again to access your account.",
      "noListings": "Room for one more",
      "noListingsSubtext": "Kit that's outgrown but still good — someone at your club needs it.",
      "noClubs": "No clubs yet",
      "noClubsSubtext": "Join a club to see it here",
      "viewClub": "View club",
      "loadError": "Failed to load profile data",
      "changePassword": "Change password",
      "dangerZone": "Danger zone",
      "setupProfile": "Set up your profile",
      "editProfile": "Edit profile",
      "editProfileTitle": "Edit profile",
      "firstName": "First name",
      "lastName": "Last name",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "firstNameTooLong": "First name must be 50 characters or less",
      "lastNameTooLong": "Last name must be 50 characters or less",
      "profileUpdated": "Profile updated",
      "profileUpdateFailed": "Failed to update profile",
      "changeAvatar": "Change photo",
      "edit": "Edit",
      "statListings": "listings",
      "statSold": "sold",
      "statClubs": "clubs"
    },
    "adminDashboard": {
      "title": "Admin Dashboard",
      "subtitle": "Platform Administration",
      "manageUsers": "Manage Users",
      "manageUsersDescription": "Promote admins and club managers",
      "manageClubs": "Manage Clubs",
      "manageClubsDescription": "Create and delete clubs",
      "notAuthorized": "You are not authorized to access this page",
      "manageOptionsDescription": "Manage categories, conditions, sizes, and sport types",
      "analytics": "Analytics",
      "analyticsDescription": "Users, listings, transactions, retention and moderation"
    },
    "adminAnalytics": {
      "title": "Analytics",
      "users": "Users",
      "totalRegistered": "Total registered",
      "new": "New",
      "active": "Active",
      "last7days": "last 7 days",
      "last30days": "last 30 days",
      "onboardingCompleted": "Onboarding completed",
      "listings": "Listings",
      "total": "Total",
      "available": "Available",
      "reserved": "Reserved",
      "sold": "Sold",
      "new7d": "New (7d)",
      "new30d": "New (30d)",
      "averagePrice": "Average price",
      "topCategories": "Top categories",
      "transactions": "Transactions & payments",
      "pending": "Pending",
      "paid": "Paid",
      "completed": "Completed",
      "disputed": "In dispute",
      "cancelled": "Cancelled",
      "avgTransactionValue": "Avg. transaction value",
      "clubs": "Clubs",
      "activeClubs": "Active clubs",
      "topByMembers": "Top 5 — most members",
      "topByListings": "Top 5 — most listings",
      "members": "members",
      "ads": "ads",
      "engagement": "Engagement & retention",
      "conversionRate": "Conversion rate",
      "conversionRateSub": "listings that actually sold",
      "messages7d": "Messages (7d)",
      "messages30d": "Messages (30d)",
      "avgMessagesPerDay": "Avg. messages/day (30d)",
      "retentionSeller": "Retention: seller",
      "retentionSellerSub": "users who listed ≥1 item",
      "retentionBuyer": "Retention: buyer",
      "retentionBuyerSub": "users who made ≥1 purchase",
      "moderation": "Moderation",
      "openReports": "Open reports",
      "openReportsSub": "items with reports, not yet handled",
      "totalHandled": "Total handled",
      "approved": "Approved",
      "deleted": "Deleted",
      "avgResolutionTime": "Avg. resolution time",
      "avgResolutionTimeSub": "time between first report and action",
      "hours": "hours",
      "kpiUsers": "Users",
      "kpiListings": "Listings",
      "kpiTransactions": "Transactions",
      "kpiGmv30d": "GMV (30d)",
      "kpiGmv": "GMV (total)",
      "copyReport": "Copy shareable report",
      "reportCopied": "Report copied to clipboard",
      "funnel": "Funnel",
      "funnelListings": "Listings",
      "funnelViewed": "Viewed (≥1 view)",
      "funnelChats": "Chats started",
      "funnelDeals": "Sold",
      "ofPrevious": "{{pct}} of previous step",
      "traction": "Traction",
      "gmvTotal": "GMV (total)",
      "gmvSub": "sum of the sale prices that were entered",
      "gmv30d": "GMV (last 30 days)",
      "gmvCoverage": "Price known for",
      "gmvCoverageSub": "sales with a price — GMV is a lower bound",
      "dealsOnPlatform": "Sold through the platform",
      "dealsOnPlatformSub": "buyer came from a Clubswap conversation",
      "dealsOffPlatform": "Sold off the platform",
      "medianDaysToSale": "Median time to sale",
      "days": "days",
      "pctSoldWithin30d": "Sold within 30 days",
      "pctSoldWithin30dSub": "of listings older than 30 days",
      "repeatSellers": "Repeat sellers (≥2 sales)",
      "repeatBuyers": "Repeat buyers (≥2 purchases)",
      "weeklyTitle": "Per week (last 12 weeks)",
      "weekCol": "Week",
      "signupsCol": "Signups",
      "listingsCol": "Listings",
      "dealsCol": "Sales",
      "chattersCol": "Active",
      "kpiOpenReports": "Open reports"
    },
    "adminSettings": {
      "title": "Platform Settings",
      "subtitle": "Configure platform-wide settings",
      "dashboardDescription": "Configure platform fees and settings",
      "clubswapFeeTitle": "Clubswap Platform Fee",
      "clubswapFeeDescription": "Fixed fee charged per transaction to support platform operations",
      "feeAmount": "Fee Amount",
      "currentFee": "Current Fee",
      "feeRangeHint": "Range: €{{min}} - €{{max}}",
      "errorFeeRequired": "Fee amount is required",
      "errorInvalidFee": "Please enter a valid fee amount",
      "errorFeeRange": "Fee must be between €{{min}} and €{{max}}",
      "successSave": "Settings saved successfully",
      "payoutScheduleTitle": "Seller payout schedule (Stripe)",
      "payoutScheduleHelper": "Only applies to sellers who onboard from now on; existing accounts keep their current schedule.",
      "payoutScheduleDefault": "Stripe default — rolling, usually within a few business days",
      "payoutScheduleWeekly": "Weekly — bundled, lower cost per payout",
      "payoutScheduleMonthly": "Monthly — lowest cost, seller waits the longest"
    },
    "manageUsers": {
      "title": "Manage Users",
      "noUsers": "No users found",
      "searchPlaceholder": "Search by name, email, or club",
      "noSearchResults": "No users match your search",
      "promoteAdmin": "Promote to Admin",
      "demoteAdmin": "Demote from Admin",
      "manageClubRole": "Manage Club Role",
      "confirmPromoteAdmin": "Promote this user to platform admin?",
      "confirmDemoteAdmin": "Remove admin privileges from this user?",
      "cannotDemoteSelf": "You cannot demote yourself",
      "successPromoteAdmin": "User promoted to admin",
      "successDemoteAdmin": "User demoted from admin",
      "successPromoteManager": "User promoted to club manager",
      "successDemoteManager": "User removed as club manager",
      "deleteUser": "Delete Account",
      "deleteModalTitle": "Delete account",
      "deleteModalSubtitle": "Mark account of {{name}} for deletion.",
      "deleteModalInfo": "This is a soft delete. The user will be blocked immediately and the account will be permanently deleted after 30 days. The reason provided is retained permanently.",
      "reasonLabel": "Reason (required)",
      "reasonPlaceholder": "Enter a reason for the deletion...",
      "deleteConfirm": "Delete account",
      "deleteSuccess": "Account marked for deletion",
      "deleteSuccessMessage": "The account of {{name}} will be permanently deleted in 30 days.",
      "scheduledForDeletion": "Scheduled for deletion",
      "deletionReason": "Reason"
    },
    "manageClubs": {
      "title": "Manage Clubs",
      "createClub": "Create New Club",
      "editClub": "Edit Club",
      "edit": "Edit",
      "delete": "Delete",
      "clubName": "Club Name",
      "clubDescription": "Description (optional)",
      "location": "Location",
      "locationPlaceholder": "e.g. Amsterdam, Rotterdam",
      "isVerified": "Verified Club",
      "adminOnly": "Admin Only",
      "transactionFee": "Club Contribution",
      "feeRange": "Range: €{{min}} - €{{max}}",
      "feeLabel": "Club Contribution (€)",
      "feePlaceholder": "1.00",
      "feeHelp": "Amount the club receives per transaction",
      "errorFeeOutOfRange": "Fee must be between €{{min}} and €{{max}}",
      "errorNameRequired": "Club name is required",
      "errorNameTooShort": "Club name must be at least 2 characters",
      "errorDuplicateName": "A club with this name already exists",
      "successCreate": "Club created successfully",
      "successUpdate": "Club updated successfully",
      "successDelete": "Club deleted successfully",
      "confirmDelete": "Are you sure you want to delete this club?",
      "searchPlaceholder": "Search by club name or description",
      "noClubs": "No clubs found",
      "noSearchResults": "No clubs match your search"
    },
    "addListing": {
      "title": "Add listing",
      "itemDetails": "Item details",
      "titleLabel": "Title",
      "titlePlaceholder": "e.g., FC Barcelona Home Jersey",
      "description": "Description",
      "descriptionPlaceholder": "Describe the item condition, size, etc.",
      "price": "Price",
      "pricePlaceholder": "0.00",
      "size": "Size",
      "sizePlaceholder": "e.g., M, L, XL",
      "category": "Category",
      "selectCategory": "Select category",
      "condition": "Condition",
      "selectCondition": "Select condition",
      "sportType": "Sport Type",
      "sportTypePlaceholder": "Select sport type (optional)",
      "club": "Club",
      "selectClub": "Select club",
      "noClub": "No club",
      "createListing": "Create listing",
      "success": "Success",
      "successMessage": "Listing created successfully!",
      "createFailed": "Failed to create listing",
      "draftFound": "Draft found",
      "draftFoundMessage": "You have a saved draft from your previous session. Would you like to restore it?",
      "draftRestored": "Draft restored",
      "draftRestoredMessage": "Your previous listing has been restored.",
      "draftSaved": "Draft saved",
      "draftIndicator": "Draft auto-saved",
      "form": {
        "club": {
          "label": "Post to club",
          "placeholder": "Select a club"
        }
      },
      "validation": {
        "selectClub": {
          "title": "Select club",
          "message": "Please select a club to post this item to."
        }
      },
      "minimumPriceHint": "Minimum price: €{{minimum}}",
      "priceTooLow": "Price must be at least €{{minimum}} to cover club and service fees"
    },
    "itemForm": {
      "title": "Add listing",
      "editTitle": "Edit listing",
      "itemDetails": "Item details",
      "titleLabel": "Title",
      "titlePlaceholder": "e.g., FC Barcelona Home Jersey",
      "description": "Description",
      "descriptionPlaceholder": "Describe the item condition, size, etc.",
      "price": "Price",
      "pricePlaceholder": "0.00",
      "size": "Size",
      "sizePlaceholder": "e.g., M, L, XL",
      "category": "Category",
      "selectCategory": "Select category",
      "condition": "Condition",
      "selectCondition": "Select condition",
      "sportType": "Sport Type",
      "sportTypePlaceholder": "Select sport type (optional)",
      "club": "Club",
      "selectClub": "Select club",
      "noClub": "No club",
      "createListing": "Create listing",
      "saveChanges": "Save changes",
      "success": "Success",
      "successMessage": "Listing created successfully!",
      "updateSuccess": "Updated",
      "updateSuccessMessage": "Your listing has been updated!",
      "createFailed": "Failed to create listing",
      "itemNotFound": "Item not found",
      "notOwner": "You can only edit your own listings",
      "cannotEditStatus": "You can only edit items that are available",
      "draftFound": "Draft found",
      "draftFoundMessage": "You have a saved draft from your previous session. Would you like to restore it?",
      "draftRestored": "Draft restored",
      "draftRestoredMessage": "Your previous listing has been restored.",
      "draftSaved": "Draft saved",
      "draftIndicator": "Draft auto-saved",
      "form": {
        "club": {
          "label": "Post to club",
          "placeholder": "Select a club"
        }
      },
      "validation": {
        "selectClub": {
          "title": "Select club",
          "message": "Please select a club to post this item to."
        }
      },
      "minimumPriceHint": "Minimum price: €{{minimum}}",
      "priceTooLow": "Price must be at least €{{minimum}} to cover club and service fees",
      "subtitle": "Good photos and an honest description sell fastest."
    },
    "clubs": {
      "title": "Clubs",
      "searchPlaceholder": "Find a club…",
      "noResults": "No clubs found",
      "noResultsSubtext": "Try a different search term",
      "noSearchResults": "No clubs found",
      "noSearchResultsSubtext": "Try a different search term",
      "memberCount_one": "{{count}} member",
      "memberCount_other": "{{count}} members",
      "loadError": "Failed to load clubs",
      "tapToViewDetails": "Tap to view details",
      "myClubs": "My clubs",
      "otherClubs": "More clubs",
      "count_one": "{{count}} club",
      "count_other": "{{count}} clubs",
      "ranking": "Ranking",
      "noClubsJoined": "You're not in a club yet",
      "noClubsJoinedSubtext": "Join a club to see its listings on Home.",
      "subtitle": "Join the clubs you belong to — you'll see their kit on Home and can list your own."
    },
    "clubDetail": {
      "title": "Club details",
      "editClub": "Edit club",
      "joinClub": "Join club",
      "leaveClub": "Leave club",
      "members": "Members",
      "recentListings": "Recent listings",
      "viewAllListings": "Browse all",
      "noListings": "Nothing listed yet",
      "noListingsSubtext": "Be the first — list a piece of kit for this club.",
      "joined": "Joined",
      "joinSuccess": "Successfully joined club!",
      "leaveSuccess": "Successfully left club!",
      "joinFailed": "Failed to join club",
      "leaveFailed": "Failed to leave club",
      "notAuthenticated": "You must be logged in to join a club",
      "clubNotFound": "Club not found",
      "clubNotFoundMessage": "Club not found",
      "loadError": "Failed to load club details",
      "logoUpdated": "Club logo updated successfully",
      "logoUpdateFailed": "Failed to update club logo",
      "listings": "Listings",
      "managers": "Managers",
      "verified": "Verified",
      "leaveConfirmTitle": "Leave {{club}}?",
      "leaveConfirmMessage": "You'll stop seeing listings from this club. You can rejoin any time."
    },
    "onboarding": {
      "loading": "Loading...",
      "welcome": {
        "title": "Welcome to Clubswap!",
        "subtitle": "The marketplace for your club's sporting gear",
        "feature1Title": "Buy & Sell",
        "feature1Description": "Trade sporting gear within your club community",
        "feature2Title": "Club-Focused",
        "feature2Description": "Connect with members of your sports clubs",
        "feature3Title": "Save money",
        "feature3Description": "Find affordable gear and give items a second life",
        "getStarted": "Get started"
      },
      "clubSelection": {
        "title": "Join your clubs",
        "subtitle": "Select the clubs you're part of to see relevant listings",
        "searchPlaceholder": "Search clubs...",
        "counter": "{{count}} club selected (max {{max}})",
        "counter_plural": "{{count}} clubs selected (max {{max}})",
        "noClubsFound": "No clubs found",
        "verifiedBadge": "✓ Verified",
        "backButton": "← Back",
        "skipButton": "Skip",
        "continueButton": "Continue"
      },
      "completion": {
        "title": "You're All Set!",
        "subtitleWithClubs": "You've joined {{count}} club",
        "subtitleWithClubs_plural": "You've joined {{count}} clubs",
        "subtitleNoClubs": "You can join clubs anytime from your profile",
        "whatsNext": "What's Next?",
        "step1": "Browse listings from your clubs",
        "step2": "Post items you want to sell",
        "step3": "Connect with club members",
        "backButton": "← Back",
        "finishButton": "Go to Clubswap",
        "finishing": "Finishing..."
      },
      "errors": {
        "loadClubsFailed": "Failed to load clubs. Please try again.",
        "maxClubsReached": "Maximum reached",
        "maxClubsMessage": "You can join up to {{max}} clubs.",
        "completeFailed": "Failed to complete onboarding. Please try again."
      }
    },
    "adminListings": {
      "title": "All Listings",
      "dashboardDescription": "View and delete any listing regardless of status",
      "subtitle": "{{count}} listings",
      "searchPlaceholder": "Search by title...",
      "deleteTitle": "Delete listing",
      "deleteMessage": "Are you sure you want to delete \"{{title}}\"? This cannot be undone.",
      "empty": "No listings found",
      "noResponses": "No responses yet",
      "engagementUnavailable": "Engagement stats (views and conversations) are not available in this environment yet.",
      "views_one": "{{count}} view",
      "views_other": "{{count}} views",
      "conversations_one": "{{count}} conversation",
      "conversations_other": "{{count}} conversations",
      "messages_one": "{{count}} message",
      "messages_other": "{{count}} messages",
      "status": {
        "all": "All",
        "available": "Available",
        "reserved": "Reserved",
        "sold": "Sold"
      }
    },
    "adminModeration": {
      "title": "Content Moderation",
      "description": "Review and moderate reported items",
      "subtitle": "{{count}} item awaiting review",
      "subtitle_plural": "{{count}} items awaiting review",
      "loading": "Loading reported items...",
      "noReports": "All Clear!",
      "noReportsDescription": "No items have been reported. Great community!",
      "seller": "Seller",
      "reports": "Reports",
      "reportDetails": "Report Details",
      "viewItem": "View Item",
      "approve": "Approve",
      "delete": "Delete",
      "approveTitle": "Approve Item",
      "approveMessage": "Are you sure you want to approve \"{{title}}\"? This will reset all reports.",
      "approveSuccess": "Item approved successfully",
      "deleteTitle": "Delete Item",
      "deleteMessage": "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
      "deleteSuccess": "Item deleted successfully",
      "reasons": {
        "inappropriate": "Inappropriate content",
        "scam": "Suspected scam",
        "copyright": "Copyright issue",
        "other": "Other"
      },
      "tabs": {
        "items": "Reported Items",
        "disputes": "Transaction Disputes"
      },
      "disputes": {
        "subtitle": "{{count}} dispute awaiting resolution",
        "subtitle_plural": "{{count}} disputes awaiting resolution",
        "noDisputes": "No Disputes!",
        "noDisputesDescription": "No transaction disputes at this time.",
        "disputed": "Disputed",
        "disputeDetails": "Dispute Details",
        "buyer": "Buyer",
        "seller": "Seller",
        "unknownItem": "Unknown Item",
        "reportedOn": "Reported on",
        "viewChat": "View Chat",
        "approvePayment": "Approve Payment",
        "issueRefund": "Issue Refund",
        "approveTitle": "Approve Payment",
        "approveMessage": "Are you sure you want to approve payment for \"{{title}}\"? This will release funds to the seller.",
        "approveSuccess": "Payment approved successfully",
        "refundTitle": "Issue Refund",
        "refundMessage": "Are you sure you want to refund \"{{title}}\"? This will return funds to the buyer.",
        "refundSuccess": "Refund issued successfully",
        "reasons": {
          "mismatch": "Item doesn't match description",
          "noShow": "Seller didn't show up for meetup",
          "damaged": "Item damaged or broken",
          "other": "Other"
        }
      }
    },
    "adminOptionLists": {
      "title": "Manage Options",
      "tabs": {
        "category": "Category",
        "condition": "Condition",
        "size": "Size",
        "sportType": "Sport Type"
      },
      "addOption": "+ Add Option",
      "viewCustomValues": "Review Custom Values",
      "form": {
        "editTitle": "Edit Option",
        "addTitle": "Add New Option",
        "value": "Internal Value",
        "labelEn": "English Label",
        "labelNl": "Dutch Label",
        "sortOrder": "Sort Order",
        "active": "Active",
        "allFieldsRequired": "Please fill in all required fields",
        "saveSuccess": "Option saved successfully"
      },
      "delete": {
        "title": "Delete Option",
        "message": "Are you sure you want to delete \"{{value}}\"? This will deactivate it.",
        "success": "Option deleted successfully"
      }
    },
    "adminCustomValues": {
      "title": "Custom Values",
      "noCustomValues": "No pending custom values",
      "usedTimes": "Used {{count}} times",
      "firstUsed": "First used",
      "promote": {
        "button": "Promote",
        "title": "Promote \"{{value}}\"",
        "similarFound": "Similar values found (select to merge):",
        "totalUsage": "Total usage: {{count}} times",
        "confirmTitle": "Confirm Promotion",
        "confirmMessage": "This will create an official option and update all items using these {{count}} value(s).",
        "confirmButton": "Promote to Official",
        "success": "Successfully promoted! Updated {{count}} items."
      },
      "form": {
        "translationsRequired": "Please provide both English and Dutch labels"
      }
    },
    "adminPayouts": {
      "title": "Payouts",
      "dashboardDescription": "Track and manage seller and club payouts",
      "tabs": {
        "sellers": "Sellers",
        "clubs": "Clubs"
      },
      "filters": {
        "all": "All",
        "pending": "Pending",
        "paid": "Paid",
        "failed": "Failed"
      },
      "seller": {
        "emptyState": "No seller payouts found",
        "amount": "Amount",
        "status": "Status",
        "iban": "IBAN",
        "accountHolder": "Account holder",
        "item": "Item",
        "mollieId": "Mollie ID",
        "markPaid": "Mark as Paid",
        "markFailed": "Mark as Failed",
        "updateIban": "Update IBAN",
        "reference": "Bank reference",
        "referencePlaceholder": "e.g. Transfer 12345",
        "failureReason": "Failure reason",
        "failureReasonPlaceholder": "e.g. Invalid IBAN",
        "updateIbanTitle": "Update Banking Details",
        "ibanLabel": "IBAN",
        "accountHolderLabel": "Account Holder Name",
        "accountHolderPlaceholder": "Name on bank account",
        "ibanPlaceholder": "NL00 BANK 0000 0000 00"
      },
      "club": {
        "emptyState": "No clubs with pending payouts",
        "pendingAmount": "Pending amount",
        "transactions": "transactions",
        "createPayout": "Create Payout",
        "confirmCreate": "Create payout of {{amount}} covering {{count}} transactions?",
        "pastPayouts": "Past Payouts"
      },
      "status": {
        "pending": "Pending",
        "paid": "Paid",
        "failed": "Failed"
      }
    },
    "adminTransactions": {
      "title": "Open transactions",
      "dashboardDescription": "View and manage open transactions",
      "subtitle": "{{count}} open transactions",
      "cancel": "Cancel",
      "reset": "Reset",
      "cancelConfirm": "Are you sure you want to cancel this transaction?",
      "resetConfirm": "Are you sure you want to reset this transaction to 'pending'?",
      "empty": "No open transactions",
      "itemDeleted": "(item deleted)",
      "lessThanDay": "< 1 day",
      "daysAgo_one": "{{count}} day",
      "daysAgo_other": "{{count}} days",
      "useRefund": "Use refund flow to reverse a paid transaction",
      "status": {
        "pending": "Pending",
        "buyer_confirmed": "Transfer Sent",
        "paid": "Paid",
        "completed": "Completed",
        "disputed": "Disputed",
        "cancelled": "Cancelled",
        "refunded": "Refunded",
        "failed": "Failed"
      }
    },
    "deleteAccount": {
      "title": "Delete account",
      "profileButton": "Delete account",
      "step1Title": "What will be deleted?",
      "step1Subtitle": "This action cannot be undone.",
      "impactListings": "active listing(s) will be removed",
      "impactTransactions": "open transaction(s) will be cancelled",
      "impactClubs": "club(s) require a new manager",
      "impactMessages": "Your messages will be anonymised",
      "impactData": "Financial records are retained for administration",
      "continueButton": "I understand, continue",
      "step2Title": "Club transfer required",
      "step2Subtitle": "You are the only manager of the club(s) below. Choose a new member as manager before continuing.",
      "step2AllRequired": "Please select a new manager for each club.",
      "step2Continue": "Confirm transfer and continue",
      "selectNewManager": "Choose new manager",
      "noMembers": "No other members available",
      "step3Title": "Final confirmation",
      "step3Subtitle": "Type your email address to confirm that you want to permanently delete your account.",
      "emailLabel": "Email address to confirm",
      "checkboxLabel": "I understand that my account will be permanently deleted and this cannot be undone.",
      "finalButton": "Permanently delete my account",
      "deleting": "Deleting account...",
      "errorTitle": "Deletion failed",
      "emailMismatch": "Email address does not match your account."
    },
    "clubLeaderboard": {
      "title": "Leaderboard",
      "subtitle": "The most active clubs on Clubswap — by members and live listings.",
      "members": "members",
      "listings": "listings",
      "noClubs": "No clubs yet",
      "noClubsSubtext": "Clubs appear here once they have members.",
      "loadError": "Failed to load leaderboard"
    }
  },
  "components": {
    "clubLogoUploader": {
      "title": "Club logo",
      "addLogo": "Add logo",
      "changeLogo": "Change logo",
      "removeLogo": "Remove logo",
      "uploading": "Uploading logo..."
    },
    "comboSelect": {
      "addCustom": "Add \"{{value}}\"",
      "searchPlaceholder": "Search {{type}}...",
      "listTypes": {
        "category": "categories",
        "condition": "conditions",
        "size": "sizes",
        "sport_type": "sports"
      },
      "custom": "Custom"
    },
    "imageUploader": {
      "title": "Product photos",
      "hint": "The first photo is the cover. Max 2 photos.",
      "uploading": "Uploading...",
      "addPhoto": "Add photo",
      "imagesCount": "{{current}}/{{max}} images"
    },
    "itemCard": {
      "price": "€{{amount}}",
      "size": "Size",
      "club": "Club",
      "noImage": "No image",
      "viewCount_one": "{{count}} viewer",
      "viewCount_other": "{{count}} viewers",
      "views_one": "{{count}} view",
      "views_other": "{{count}} views"
    },
    "welcomeHero": {
      "welcomeBack": "Welcome back,",
      "guest": "Guest",
      "items": "items",
      "new": "new",
      "last24h": "Last 24h",
      "clubs": "clubs",
      "searchPlaceholder": "Search gear…",
      "browseAll": "Browse all",
      "newToday": "new today"
    },
    "clubFilter": {
      "allClubs": "All clubs",
      "filterByClub": "Filter by club",
      "unknownClub": "Unknown club"
    },
    "emptyStateNoClubs": {
      "title": "Join a club to start trading",
      "subtitle": "Clubswap shows kit from the clubs you belong to.",
      "button": "Browse clubs"
    },
    "sectionHeader": {
      "count_one": "{{count}} item",
      "count_other": "{{count}} items"
    }
  },
  "navigation": {
    "home": "Home",
    "browse": "Browse",
    "clubs": "Clubs",
    "profile": "Profile",
    "conversations": "Messages",
    "loading": "Loading...",
    "login": "Log in",
    "register": "Create account",
    "addListing": "Add listing",
    "signUp": "Sign up"
  },
  "dialogs": {}
}
